module.exports = __webpack_public_path__ + "static/media/luminatouch-3.ae641474.jpg";